import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { connect } from 'react-redux'
import Sprite from '~components/Sprite'
import Button from '~components/ui/Button'

class ShippingCosts extends Component {
  constructor (props) {
    super(props)

    this.state = {
      shippingMessage: [],
      stockist: [],
      country: props?.stockist?.country
    }
  }

  componentDidMount () {
    axios.get('/options', {
      params: {
        option: 'shipping_costs'
      }
    })
      .then(response => {
        const shippingOptions = response.data.fields.shipping_options

        const costs = shippingOptions.filter(cost => {
          if (cost.attributes.country_code === this.state.country) {
            return true
          }

          return false
        })

        if (costs[0]) {
          this.setState({
            shippingMessage: costs[0].attributes.message
          })
        } else {
          this.setState({
            shippingMessage: response.data.fields.message
          })
        }
      })
  }

  render () {
    return (
      <div className="fixed z-50 p-4 md:p-8 flex flex-col top-0 left-0 right-0 bottom-0 bg-charcoal bg-opacity-75">
        <div className="bg-white sm:bg-lightGrey w-full m-auto max-w-screen-mdxl px-4 py-8 sm:p-15 sm:pb-0 overflow-scrolling overflow-x-hidden overflow-y-auto relative">
          <button type="button" className="w-10 h-10 absolute top-3 right-1 sm:top-8 sm:right-7 block" aria-label="Close" onClick={this.props.onClose}>
            <span className="w-4 h-4 icon block m-auto" aria-hidden="true">
              <Sprite name="cross" />
            </span>
          </button>

          <h3 className="text-md lg:text-2xl border-b border-coral pb-6">
            Shipping Costs
          </h3>

          <div className="mt-6 flex flex-wrap -mx-2 sm:py-6 relative">
            <div className="w-full px-2 my-2">
              {this.state.shippingMessage}
            </div>
          </div>

          <div className="mt-6 flex flex-wrap -mx-2 sm:bg-white sm:py-8 relative before:bg-white after:bg-white before:-left-max after:-right-max content-after content-before sm:content-before sm:content-after before:absolute after:absolute before:w-max after:w-max before:top-0 after:top-0 before:h-full after:h-full" tw-content-before="" tw-content-after="">
            <div className="w-full">
              <Button
                theme="black-to-red"
                className="w-full"
                onClick={this.props.onClose}
              >
                Close
              </Button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

ShippingCosts.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  stockist: PropTypes.object
}

const mapDispatchToProps = dispatch => ({
  dispatch
})
const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  stockist: state.auth.account.stockist
})

export default connect(mapStateToProps, mapDispatchToProps)(ShippingCosts)
